import { Component, OnInit } from '@angular/core';
import { LocalDataSource } from 'angular2-smart-table';
import { EventManagerService, IEventManager } from '../../services/database/event/eventmanager.service';
import { UserService } from '../../services/database/user/user.service';
import { ToastrService } from '../../services/toastr/toastr.service';
import { ActivatedRoute } from '@angular/router';
import { IUser } from '../../services/model/user.model';
import { SearchService } from '../../services/search/search.service';
import { IEventUser } from '../../services/database/event/event.service';

@Component({
  selector: 'ngx-managers',
  templateUrl: './managers.component.html',
  styleUrls: ['./managers.component.scss']
})
export class ManagersComponent implements OnInit {

  managers: IEventManager[];
  source: LocalDataSource = new LocalDataSource();
  searchValue: string;
  users: any[];
  userKey: string;
  eventId: string;

  settings = {
    actions: {
      add: false,
      edit: false,
      delete: true,
      position: 'right'
    },
    delete: {
      deleteButtonContent: '<i class="nb-trash"></i>',
      confirmDelete: true,
    },
    columns: {
      key: {
        title: 'ID',
        show: 'false'
      },
      userId: {
        title: 'User',
        type: 'string'
      },
      firstName: {
        title: 'First Name',
        type: 'string',
      },
      lastName: {
        title: 'Last Name',
        type: 'string',
      }
    },
  };

  constructor(
    private managerservice: EventManagerService,
    private userService: UserService,
    private searchService: SearchService,
    private toastrService: ToastrService,
    private route: ActivatedRoute
  ) {
  }

  ngOnInit(): void {
    this.eventId = this.route.snapshot.paramMap.get('eventId');
    this.managerservice.getManagers(this.eventId).subscribe((managers) => {
      const data = [];
      managers.forEach(manager => {
        data.push({
          firstName: manager.user ? manager.user.firstName : '',
          lastName: manager.user ? manager.user.lastName : '',
          userId: manager.user_id,
          key: manager.key
        })
      })
      this.source.load(data);
    })
  }

  onDeleteConfirm(event): void {
    if (window.confirm('Are you sure you want to delete this manager?')) {
      this.managerservice.deleteManager(event.data.key).then((succes) => {
        this.userKey = null;
        this.searchValue = null;
        this.toastrService.show('Success', 'Successfully deleted manager', 'success');
        event.confirm.resolve();
      })
        .catch((error) => {
          this.userKey = null;
          this.searchValue = null;
          this.toastrService.show('Error', error, 'danger')
        })
    } else {
      event.confirm.reject();
    }
  }

  search() {
    const searchValue = this.searchValue;
    if (searchValue === '') {
      this.users = [];
    }
    else if (searchValue && searchValue.length > 1) {
      setTimeout(() => {
        this.searchService.searchUser(searchValue, this.eventId).then((eventusers) => {
          this.users = eventusers.hits;
        })
      })
    }
    else {
      this.users = [];
    }
  }

  clickItem(user: any) {
    this.searchValue = user.firstName + " " + user.lastName;
    this.userKey = user.objectID;
  }

  addUser() {
    if (!this.searchValue || !this.userKey) {
      return;
    }
    this.managerservice.addManager({
      user_id: this.userKey,
      event_id: this.eventId
    }).then((succes) => {
      this.searchValue = '';
      this.userKey = null;
      this.toastrService.show('Success', 'Successfully added manager', 'success')
    })
      .catch((error) => {
        this.toastrService.show('Error', error, 'danger')
      })
  }

}
